import { Controller } from "@hotwired/stimulus"

const CREATE_OPTION_VALUE = "__create__"

export default class extends Controller {
  static targets = ["selectField", "textField", "select", "textInput"]

  connect () {
    if (this.textInputTarget.value.trim().length > 0) {
      this.showTextField({ focus: false })
    }
  }

  toggle (event) {
    if (event.target.value === CREATE_OPTION_VALUE) {
      this.showTextField()
    }
  }

  showTextField ({ focus = true } = {}) {
    this.selectFieldTarget.classList.add("hidden")
    this.textFieldTarget.classList.remove("hidden")
    this.selectTarget.disabled = true
    if (focus) this.textInputTarget.focus()
    this.notifyPreview()
  }

  showSelect () {
    this.selectFieldTarget.classList.remove("hidden")
    this.textFieldTarget.classList.add("hidden")
    this.selectTarget.disabled = false
    this.selectTarget.value = ""
    this.textInputTarget.value = ""
    this.notifyPreview()
  }

  notifyPreview () {
    this.element.dispatchEvent(new CustomEvent("benefit-category-field:changed", { bubbles: true }))
  }
}
